import axiosConfig from './axiosConfig';

const apiChargeCategory = {
   list: (filter) => axiosConfig.requests.get(`/chargeCategories?PageNumber=${filter.pageNumber}&PageSize=${filter.pageSize}`),
};

export default { apiChargeCategory };
